/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Icon, { IconColor, IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import Storage from 'common/lib/storage';
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import React from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getMe } from 'selectors';
// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';
import HeaderLink from './header-link';

import styles from './header.less';

const format = forTemplate('header_back_menu_button');

interface BackToHomeLinkStateProps {
  me: MemberModel | undefined;
}

class BackToHomeLink extends React.Component<BackToHomeLinkStateProps> {
  onClick = (e: React.MouseEvent<HTMLElement>) => {
    const { me } = this.props;
    const cachedRoute = me
      ? String(Storage.get(`home_${me.id}_last_tab_2`))
      : null;
    let tab = '';
    if (cachedRoute === '/') {
      tab = 'home';
    } else if (cachedRoute && cachedRoute.endsWith('/boards')) {
      tab = 'boards';
    } else if (
      cachedRoute &&
      (cachedRoute.endsWith('/home') ||
        cachedRoute.endsWith('/highlights') ||
        cachedRoute.includes('/cards/'))
    ) {
      tab = 'team';
    }

    Analytics.trackUE({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.LANDING_TAB,
      method: 'by clicking home icon',
      context: {
        landingtab: tab,
      },
    });
  };
  render() {
    return (
      <HeaderLink
        aria-label={format('backToHome')}
        buttonStyle={'headerButton'}
        className={styles.backToHomeLink}
        onClick={this.onClick}
        href={'/'}
      >
        <Icon color={IconColor.Light} large name={IconName.House} />
      </HeaderLink>
    );
  }
}

const mapStateToProps = (state: State): BackToHomeLinkStateProps => {
  return {
    me: getMe(state),
  };
};

export default connect(mapStateToProps)(BackToHomeLink);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/back-to-home-link.tsx